import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const ProductLaunchCampaign = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12743"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12743)">
          <rect
            x="-1"
            width="116"
            height="110"
            rx="3.74825"
            fill="#D0F9E9"
          />
          <rect
            x="72.6598"
            y="19.4518"
            width="32.9868"
            height="14.3802"
            rx="0.877202"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
          />
          <g clipPath="url(#clip0_1529_12743)">
            <path
              d="M82.5085 26.6622C82.5085 28.3308 81.2934 29.7138 79.705 29.9645V27.6285H80.4792L80.6265 26.6622H79.705V26.0352C79.705 25.7707 79.8338 25.5131 80.2465 25.5131H80.6655V24.6904C80.6655 24.6904 80.2852 24.6252 79.9216 24.6252C79.1628 24.6252 78.6667 25.0879 78.6667 25.9258V26.6622H77.8231V27.6285H78.6667V29.9645C77.0784 29.7138 75.8633 28.3308 75.8633 26.6622C75.8633 24.8161 77.3509 23.3193 79.1859 23.3193C81.0208 23.3193 82.5085 24.8161 82.5085 26.6622Z"
              fill="#1877F2"
            />
            <path
              d="M80.4794 27.6021L80.6267 26.6416H79.7052V26.0184C79.7052 25.7556 79.8339 25.4995 80.2466 25.4995H80.6656V24.6818C80.6656 24.6818 80.2854 24.6169 79.9219 24.6169C79.1629 24.6169 78.6669 25.0769 78.6669 25.9096V26.6416H77.8232V27.6021H78.6669V29.9239C78.836 29.9504 79.0094 29.9642 79.186 29.9642C79.3626 29.9642 79.536 29.9504 79.7052 29.9239V27.6021H80.4794Z"
              fill="white"
            />
          </g>
          <rect
            x="85.166"
            y="24.6487"
            width="13.6226"
            height="1.32904"
            rx="0.332259"
            fill="#1E1E1E"
          />
          <rect
            x="85.166"
            y="27.3066"
            width="17.6097"
            height="1.32904"
            rx="0.332259"
            fill="#1E1E1E"
          />
          <rect
            x="72.6598"
            y="38.3505"
            width="32.9868"
            height="14.3802"
            rx="0.877202"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
          />
          <g clipPath="url(#clip1_1529_12743)">
            <path
              d="M77.5465 48.4477H76.2912V44.5025H77.5465V48.4477ZM80.1527 45.662C80.0061 45.662 79.8655 45.7195 79.7619 45.822C79.6582 45.9245 79.6 46.0635 79.6 46.2085V48.4477H78.2801V44.5025H79.6V44.9086C79.9093 44.6496 80.3002 44.5052 80.7055 44.4999C81.5243 44.4999 82.0925 45.1001 82.0925 46.2391V48.4477H80.7055V46.2085C80.7058 46.1365 80.6918 46.0652 80.6641 45.9986C80.6365 45.932 80.5958 45.8714 80.5445 45.8204C80.4931 45.7694 80.4321 45.7289 80.3648 45.7013C80.2976 45.6736 80.2255 45.6594 80.1527 45.6594V45.662ZM77.5698 43.2715C77.5698 43.3978 77.5319 43.5212 77.461 43.6262C77.39 43.7312 77.2892 43.8131 77.1712 43.8614C77.0532 43.9097 76.9233 43.9224 76.7981 43.8977C76.6728 43.8731 76.5578 43.8123 76.4675 43.723C76.3771 43.6337 76.3156 43.5199 76.2907 43.3961C76.2658 43.2722 76.2786 43.1439 76.3275 43.0272C76.3763 42.9105 76.4591 42.8108 76.5653 42.7407C76.6715 42.6705 76.7963 42.6331 76.9241 42.6331C77.0944 42.6344 77.2573 42.7023 77.3773 42.8219C77.4973 42.9414 77.5646 43.1031 77.5646 43.2715H77.5698Z"
              fill="#0A66C2"
              stroke="#0A66C2"
              strokeWidth="0.0620197"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <rect
            x="85.166"
            y="42.2178"
            width="13.6226"
            height="1.32904"
            rx="0.332259"
            fill="#1E1E1E"
          />
          <rect
            x="85.166"
            y="44.876"
            width="8.30648"
            height="1.32904"
            rx="0.332259"
            fill="#1E1E1E"
          />
          <rect
            x="85.166"
            y="47.5339"
            width="10.9646"
            height="1.32904"
            rx="0.332259"
            fill="#1E1E1E"
          />
          <rect
            x="72.6598"
            y="57.249"
            width="32.9868"
            height="14.3802"
            rx="0.877202"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
          />
          <g clipPath="url(#clip2_1529_12743)">
            <path
              d="M79.4775 61.7075C80.4426 61.7075 80.5571 61.7111 80.9384 61.7285C81.918 61.7731 82.3755 62.2379 82.4201 63.2103C82.4376 63.5913 82.4409 63.7058 82.4409 64.6709C82.4409 65.6363 82.4373 65.7505 82.4201 66.1315C82.3752 67.103 81.9189 67.5687 80.9384 67.6132C80.5571 67.6307 80.4432 67.6343 79.4775 67.6343C78.5124 67.6343 78.3979 67.6307 78.0168 67.6132C77.0349 67.5684 76.5797 67.1015 76.5351 66.1312C76.5177 65.7502 76.514 65.636 76.514 64.6706C76.514 63.7055 76.518 63.5913 76.5351 63.21C76.58 62.2379 77.0364 61.7728 78.0168 61.7282C78.3982 61.7111 78.5124 61.7075 79.4775 61.7075ZM79.4775 61.0559C78.4958 61.0559 78.3729 61.0601 77.9873 61.0776C76.6746 61.1378 75.945 61.8662 75.8848 63.1801C75.867 63.566 75.8628 63.6889 75.8628 64.6706C75.8628 65.6523 75.867 65.7755 75.8845 66.161C75.9447 67.4738 76.6731 68.2033 77.987 68.2636C78.3729 68.2811 78.4958 68.2853 79.4775 68.2853C80.4592 68.2853 80.5824 68.2811 80.9679 68.2636C82.2795 68.2033 83.0108 67.475 83.0702 66.161C83.0879 65.7755 83.0922 65.6523 83.0922 64.6706C83.0922 63.6889 83.0879 63.566 83.0705 63.1804C83.0114 61.8689 82.2822 61.1381 80.9682 61.0779C80.5824 61.0601 80.4592 61.0559 79.4775 61.0559V61.0559ZM79.4775 62.8144C78.4524 62.8144 77.6213 63.6455 77.6213 64.6706C77.6213 65.6957 78.4524 66.527 79.4775 66.527C80.5025 66.527 81.3336 65.696 81.3336 64.6706C81.3336 63.6455 80.5025 62.8144 79.4775 62.8144ZM79.4775 65.8755C78.8121 65.8755 78.2726 65.3363 78.2726 64.6706C78.2726 64.0052 78.8121 63.4657 79.4775 63.4657C80.1429 63.4657 80.6824 64.0052 80.6824 64.6706C80.6824 65.3363 80.1429 65.8755 79.4775 65.8755ZM81.4071 62.3075C81.1673 62.3075 80.973 62.5018 80.973 62.7413C80.973 62.9807 81.1673 63.175 81.4071 63.175C81.6466 63.175 81.8406 62.9807 81.8406 62.7413C81.8406 62.5018 81.6466 62.3075 81.4071 62.3075Z"
              fill="url(#paint0_linear_1529_12743)"
            />
          </g>
          <rect
            x="85.75"
            y="62.677"
            width="9.96777"
            height="1.32904"
            rx="0.332259"
            fill="#1E1E1E"
          />
          <rect
            x="85.75"
            y="65.335"
            width="15.2839"
            height="1.32904"
            rx="0.332259"
            fill="#1E1E1E"
          />
          <rect
            x="72.6598"
            y="76.1476"
            width="32.9868"
            height="14.3802"
            rx="0.877202"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
          />
          <g clipPath="url(#clip3_1529_12743)">
            <path
              d="M81.9859 81.3486H76.8484C76.705 81.3486 76.5674 81.4071 76.466 81.5113C76.3646 81.6154 76.3076 81.7566 76.3076 81.9039V85.2355C76.3076 85.3828 76.3646 85.524 76.466 85.6282C76.5674 85.7323 76.705 85.7908 76.8484 85.7908H81.9859C82.1293 85.7908 82.2669 85.7323 82.3683 85.6282C82.4697 85.524 82.5267 85.3828 82.5267 85.2355V81.9039C82.5267 81.7566 82.4697 81.6154 82.3683 81.5113C82.2669 81.4071 82.1293 81.3486 81.9859 81.3486Z"
              fill="#E3E3E3"
            />
            <path
              d="M76.8348 81.3486C76.695 81.3486 76.5609 81.4071 76.462 81.5113C76.3632 81.6154 76.3076 81.7566 76.3076 81.9039V85.2355C76.3076 85.3828 76.3632 85.524 76.462 85.6282C76.5609 85.7323 76.695 85.7908 76.8348 85.7908H76.9766L81.194 81.3486H76.8348Z"
              fill="white"
            />
            <path
              d="M81.9859 81.3486H76.8484C76.705 81.3486 76.5674 81.4071 76.466 81.5113C76.3646 81.6154 76.3076 81.7566 76.3076 81.9039V85.2355C76.3076 85.3828 76.3646 85.524 76.466 85.6282C76.5674 85.7323 76.705 85.7908 76.8484 85.7908H81.9859C82.1293 85.7908 82.2669 85.7323 82.3683 85.6282C82.4697 85.524 82.5267 85.3828 82.5267 85.2355V81.9039C82.5267 81.7566 82.4697 81.6154 82.3683 81.5113C82.2669 81.4071 82.1293 81.3486 81.9859 81.3486Z"
              stroke="#191919"
              strokeWidth="0.444217"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.3046 81.5706L79.4172 84.0138L76.5298 81.5706"
              stroke="#191919"
              strokeWidth="0.444217"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <rect
            x="85.6289"
            y="81.5762"
            width="9.96777"
            height="1.32904"
            rx="0.332259"
            fill="#1E1E1E"
          />
          <rect
            x="85.6289"
            y="84.2341"
            width="15.2839"
            height="1.32904"
            rx="0.332259"
            fill="#1E1E1E"
          />
          <path
            d="M50.4638 58.2722L47.9907 54.0121L48.2401 53.5215L50.2265 49.6487C50.3293 49.436 50.347 49.1924 50.276 48.9666C50.2051 48.7407 50.0508 48.5494 49.844 48.4307L45.5618 45.9537L45.2938 41.0566C45.2836 40.8782 45.2221 40.7061 45.1165 40.5607C45.011 40.4153 44.8658 40.3026 44.6981 40.2359C44.5848 40.188 44.463 40.1631 44.34 40.1626L39.4012 40.1216L36.7 35.9989C36.5648 35.7984 36.3585 35.6552 36.1223 35.598C35.8861 35.5407 35.6372 35.5736 35.4252 35.69L31.1362 38.1185L26.7302 35.8869C26.5156 35.784 26.2701 35.7649 26.0426 35.8334C25.8152 35.9018 25.6227 36.0528 25.5034 36.2562L23.0189 40.4881L18.0764 40.7275C17.833 40.7387 17.6038 40.8425 17.4366 41.0173C17.2694 41.1922 17.1771 41.4246 17.179 41.666L17.1602 46.5649L13.8477 48.6771L13.7975 48.7073L13.0128 49.2127C12.811 49.3425 12.6673 49.5441 12.611 49.7761C12.5548 50.0082 12.5903 50.2532 12.7103 50.461L13.0822 51.1042L13.6314 52.0523L13.672 52.118L15.1834 54.7212L12.9572 59.085C12.845 59.2985 12.8204 59.5471 12.8886 59.779C12.9569 60.0108 13.1126 60.2081 13.3235 60.3298L17.6076 62.8073L17.8755 67.7044C17.8885 67.9432 17.9932 68.1685 18.1682 68.3341C18.3431 68.4998 18.5751 68.5932 18.8165 68.5953L23.7645 68.6385L25.8975 71.8913L25.9516 71.9815L26.4657 72.7612C26.5978 72.9617 26.802 73.1051 27.0366 73.162C27.2711 73.2188 27.5183 73.1849 27.7276 73.067L30.1112 71.718L32.0166 70.6385L36.4335 72.865C36.6499 72.9773 36.9012 73.0026 37.1351 72.9358C37.369 72.869 37.5674 72.7152 37.6889 72.5065L40.1688 68.2774L45.1118 68.0361C45.3552 68.025 45.5844 67.9211 45.7516 67.7463C45.9188 67.5714 46.0111 67.3391 46.0092 67.0976L46.0157 63.9048L46.021 62.1952L50.1702 59.5401C50.3723 59.4083 50.5161 59.2053 50.5726 58.972C50.6292 58.7386 50.5943 58.4923 50.4749 58.2826L50.4638 58.2722Z"
            fill="#FFEF5E"
          />
          <path
            d="M13.6307 52.0581L12.7095 50.4646C12.5895 50.2567 12.5539 50.0117 12.6102 49.7796C12.6664 49.5475 12.8102 49.3459 13.0121 49.216L17.1629 46.5606L17.1818 41.6588C17.1827 41.4197 17.2759 41.1904 17.4423 41.0179C17.6087 40.8454 17.8358 40.7428 18.0769 40.7311L23.0219 40.49L25.503 36.2583C25.6223 36.0537 25.8156 35.9017 26.0441 35.8331C26.2725 35.7644 26.5192 35.784 26.7345 35.888L31.1512 38.1244L35.4418 35.6955C35.6511 35.5777 35.8984 35.5437 36.1331 35.6006C36.3678 35.6575 36.5721 35.8009 36.7043 36.0015L39.4067 40.1252L44.3568 40.1687C44.5983 40.1708 44.8304 40.2643 45.0054 40.4299C45.1804 40.5956 45.2852 40.8209 45.2982 41.0598L45.5665 45.958L49.8524 48.4362C50.0639 48.5577 50.2202 48.755 50.2888 48.987C50.3574 49.2191 50.3331 49.468 50.2208 49.6818L47.9983 54.0283L50.4727 58.2894C50.5927 58.4973 50.6283 58.7424 50.572 58.9745C50.5158 59.2066 50.372 59.4082 50.1701 59.538L46.0194 62.1935L46.01 67.0957C46.0119 67.3371 45.9196 67.5696 45.7524 67.7444C45.5851 67.9193 45.3558 68.0232 45.1123 68.0343L40.1673 68.2753L37.6862 72.5071C37.5643 72.7154 37.3658 72.8688 37.132 72.9352C36.8981 73.0017 36.6469 72.9761 36.4307 72.8638L32.0118 70.6366L27.7212 73.0654C27.5119 73.1833 27.2646 73.2172 27.0299 73.1603C26.7952 73.1035 26.5909 72.9601 26.4588 72.7595L25.9448 71.9778"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.1577 63.6309L12.7037 67.4024"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.0332 46.8218L33.7093 61.1521"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.2009 60.3977L12.1946 66.6481L10.6675 64.3851L24.5409 47.576L33.2009 60.3962L33.2009 60.3977Z"
            fill="#FF5A4F"
          />
          <path
            d="M33.2009 60.3977L12.1946 66.6481L10.6675 64.3851L24.5409 47.576L33.2009 60.3962L33.2009 60.3977Z"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.1254 63.3949C23.4143 63.7212 23.6328 64.1025 23.7676 64.5151C23.9025 64.9277 23.9507 65.3629 23.9093 65.7939C23.8679 66.2248 23.7378 66.6424 23.527 67.0207C23.3162 67.3991 23.0292 67.7302 22.6837 67.9936C22.3382 68.2571 21.9416 68.4472 21.5183 68.5524C21.0951 68.6575 20.6541 68.6754 20.2227 68.605C19.7913 68.5346 19.3786 68.3773 19.0102 68.1428C18.6417 67.9084 18.3252 67.6018 18.0803 67.2419L16.7504 65.2727"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.9868 50.5857L35.3058 45.9339"
            stroke="black"
            strokeWidth="0.90367"
            strokeLinecap="round"
          />
          <path
            d="M33.0239 53.0959L36.9316 53.0574"
            stroke="black"
            strokeWidth="0.90367"
            strokeLinecap="round"
          />
          <path
            d="M61.5537 30.291L57.7378 33.235"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M58.5815 29.949L61.5881 30.3356L61.1991 33.3419"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M62.0898 48.6199L57.2703 48.6199"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.9455 50.7078L62.0898 48.5651L59.9455 46.4224"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M62.0898 64.3533L57.2703 64.3533"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.9455 66.4395L62.0898 64.2968L59.9455 62.1541"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M61.5532 82.5718L57.7373 79.6278"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M58.581 82.913L61.5876 82.5264L61.1987 79.5201"
            stroke="#1E1E1E"
            strokeWidth="0.90367"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1529_12743"
            x1="80.9836"
            y1="61.0559"
            x2="78.432"
            y2="67.8423"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5E5CCB" />
            <stop
              offset="0.18214"
              stopColor="#8D40B7"
            />
            <stop
              offset="0.431696"
              stopColor="#DA2E7C"
            />
            <stop
              offset="0.753527"
              stopColor="#F15544"
            />
            <stop
              offset="1"
              stopColor="#FECA66"
            />
          </linearGradient>
          <clipPath id="clip0_1529_12743">
            <rect
              width="6.64518"
              height="6.64518"
              fill="white"
              transform="translate(75.8628 23.3196)"
            />
          </clipPath>
          <clipPath id="clip1_1529_12743">
            <rect
              width="6.64518"
              height="6.64518"
              fill="white"
              transform="translate(75.8628 42.2178)"
            />
          </clipPath>
          <clipPath id="clip2_1529_12743">
            <rect
              width="7.22936"
              height="7.22936"
              fill="white"
              transform="translate(75.8628 61.0559)"
            />
          </clipPath>
          <clipPath id="clip3_1529_12743">
            <rect
              width="7.10748"
              height="7.10748"
              fill="white"
              transform="translate(75.8633 80.0159)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
